import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';

import { SessionsService } from '../../services/sessions/sessions.service';
import { ChatService } from '../../services/chat/chat.service';
import { ParticipantFsDolby } from '@sc/types';
import { AnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'sc-invite-chat-group-menu',
  templateUrl: './invite-chat-group-menu.component.html',
  styleUrls: ['./invite-chat-group-menu.component.scss'],
})
export class InviteChatGroupMenuComponent implements OnInit, OnDestroy {
  @Input() chatGroupID: string;
  studioSession$ = this.sessionsService.studioSession$;
  participantsInChatGroup: Array<ParticipantFsDolby> = [];
  subs: Array<Subscription> = [];

  constructor(
    private chatService: ChatService,
    private sessionsService: SessionsService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.setupParticipantsInChatGroup();
  }

  async toggleParticipantInChatGroup(toggle: any, participant: ParticipantFsDolby) {
    if (toggle.detail.checked) {
      this.chatService.addParticipantToChatGroup(
        this.studioSession$.value.sessionID,
        this.chatGroupID,
        participant.uid
      );
    } else {
      this.chatService.removeParticipantFromChatGroup(
        this.studioSession$.value.sessionID,
        this.chatGroupID,
        participant.uid
      );
    }

    await this.analyticsService.track('toggled participant in chat group', {
      enabled: toggle.detail.checked,
      chatGroupID: this.chatGroupID,
      participantUID: participant.uid,
    });
  }

  /**
   * Sets up the participants that are or are not in this chat group
   */
  setupParticipantsInChatGroup() {
    const sub = combineLatest([
      this.sessionsService.getAllParticipantsInSession(this.studioSession$.value.sessionID),
      this.chatService.getChatGroupByID(this.studioSession$.value.sessionID, this.chatGroupID),
    ]).subscribe(([participants, chatGroup]) => {
      if (!chatGroup) return;
      this.participantsInChatGroup = participants.map((participant) => {
        const isChecked = !!chatGroup.users.find((uid) => uid === participant.uid);

        return {
          uid: participant.uid,
          name: participant.name,
          isChecked,
        };
      });
    });

    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe);
  }
}
